import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";  // Asegúrate de que useDispatch esté importado
import { useNavigate } from "react-router-dom";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const NotFound = () => {
  const dispatch = useDispatch(); // Aunque no se usa para dispatch, lo mantenemos aquí por si se necesita en el futuro
  const navigate = useNavigate(); // Para redirigir al usuario

  // Accedemos al estado de user desde Redux
  const { userInfo, error } = useSelector((state) => state.user); // Estado del userSlice

  const redirectUrl = () => {
    navigate("/"); // Redirigimos al usuario a la página principal
  };

  useEffect(() => {
    // Verificamos si el usuario está logueado
    if (userInfo) {
      if (userInfo.userType === "Admin") {
        navigate("/admin"); // Redirige al dashboard de admin si el tipo de usuario es Admin
      } else if (userInfo.userType === "Guest") {
        navigate("/guest/ordenes"); // Redirige al dashboard de Guest si es un Guest
      }
    }
  }, [userInfo, navigate]); // Dependemos de userInfo para redirigir al usuario cuando se carga

  const particlesInit = useCallback(async (engine) => {
      await loadSlim(engine);
    }, []);
  
    const particlesLoaded = useCallback(async (container) => {}, []);

  return (
    <div style={{
      position: "relative",
      height: "100vh",
      width: "100vw",
      overflow: "hidden",
    }}>
      <Particles
              id="tsparticles"
              init={particlesInit}
              loaded={particlesLoaded}
              options={{
                background: { color: "#000" },
                fpsLimit: 60,
                particles: {
                  number: { value: 110 },
                  color: { value: "#ffffff" },
                  move: { enable: true, speed: 1, direction: "none" },
                  size: { value: 3 },
                  opacity: { value: 0.5 },
                  links: {
                    enable: true,
                    color: "#ffffff",
                    distance: 150,
                    opacity: 0.5,
                    width: 1,
                  },
                },
                interactivity: {
                  events: {
                    onHover: { enable: true, mode: "repulse" },
                    onClick: { enable: true, mode: "push" },
                  },
                },
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                zIndex: -1,
              }}
            />

<div className="absolute inset-0 flex flex-col items-center justify-center z-10">
  <h1 className="text-[150px] font-bold text-white">404</h1>
  <p className="sm:text-5xl text-3xl font-semibold text-white block mt-5">Pagina no encontrada</p>
</div>

      
    </div>
  );
};

export default NotFound;
